import { Card } from "antd";
import React from "react";

export const SettingCard = ({ title = "", children = [], ...props }) => {
  return (
    <Card size="small" title={title} {...props}>
      {children}
    </Card>
  );
};
